import { Environment } from './type/environment.type';

export const environment: Environment = {
  envName: '#{environment}#',
  apiBaseUrl: '#{apiBaseUrl}#',
  analytics: {
    appVersion: '#{analyticsAppVersion}#',
    segmentWriteKey: '#{analyticsSegmentWriteKey}#',
    amplitudeSessionReplayKey: '#{analyticsAmplitudeSessionReplayKey}#',
    isSessionReplayEnabled: Boolean('#{isSessionReplayEnabled}#'),
    isTrackingEnabled: Boolean('#{isAnalyticsEnabled}#'),
  },
};
